<hr class="divider my-4 border-t border-solid" [ngClass]="cssClass" />
